import { getValueLanguageConent } from '@/tools/languageValue';
import { logger } from '@/tools/logger';
/**
 * This method returns the value from the store addressed by the uri
 * f.e.: store://state.value.subvalu or store://getters.value
 * if an language Content Value is requested and you want the language Object
 * set resolveLanguageContent to false, default value is true
 * @param {*} content
 * @param {*} store
 * @param { resolveLanguageContent } _options
 */
export function resolveStateURI(URI, store, _options) {
	const options = Object.assign(
		{
			resolveLanguageContent: true,
		},
		_options
	);
	const storePath = URI.slice(8).split('.');
	let result = store[storePath[0]];

	if (typeof result === 'undefined') {
		logger.log(`Could not find Store Value with path ${storePath[0]} in ${storePath}`);
		return undefined;
	}
	for (let i = 1; i < storePath.length; i++) {
		if (result === null) return null;
		if (typeof result[storePath[i]] === 'undefined') {
			logger.log(`Could not find Store Value with path ${storePath[i]} in ${storePath} `);
			return undefined;
		}
		if (storePath[i] === 'languageContent') {
			// here language Content is reduce to an ObjectMap so it behaves like language butto content values
			if (options.resolveLanguageContent) {
				return getValueLanguageConent(result[storePath[i]], storePath[i + 1]);
			} else {
				return result[storePath[i]].reduce((acc, lc) => {
					acc[lc.languageISO] = lc[storePath[i + 1]];
					return acc;
				}, {});
			}
		} else {
			result = result[storePath[i]];
		}
	}
	return result;
}
